export default __webpack_public_path__ + "static/itmatrix-favicon-a1919a04c58817a57739d188b7523b44.png";